import { render, staticRenderFns } from "./CategoryTypeListItem.vue?vue&type=template&id=67d476b4&scoped=true&"
import script from "./CategoryTypeListItem.vue?vue&type=script&lang=js&"
export * from "./CategoryTypeListItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTypeListItem.vue?vue&type=style&index=0&id=67d476b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d476b4",
  null
  
)

export default component.exports